import React, { useEffect, useReducer } from 'react';
import { useForm } from 'react-hook-form';
// import { useHistory } from 'react-router';
import { showService } from './showService';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';

const initialState = {
    isLoading: false,
    isSubmitting: false,
    serverCommunication: undefined,
    showId: undefined
}

const ACTIONS = {
    SHOW_CREATE_CALL: 'SHOW_CREATE_CALL',
    SHOW_CREATE_SUCCESS: 'SHOW_CREATE_SUCCESS',
    SHOW_CREATE_ERROR: 'SHOW_CREATE_ERROR'
}

const statusOptions = [
    'Draft',
    'PreShow',
    'Active',
    'PostGame',
    'Archived'
]
function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.SHOW_CREATE_CALL:
            return {
                ...state,
                isLoading: true
            };
        case ACTIONS.SHOW_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                showId: action.data.id
            };
        case ACTIONS.SHOW_CREATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                serverCommunication: action.data
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}


function ShowCreate() {

    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, formState: { errors } } = useForm();
    // const history = useHistory();
    const navigate = useNavigate();
    const {contextValue } = useAuth();

    useEffect(() => {
        if (state.showId) {
            // history.push(`/show/${state.showId}`);
            navigate(`/show/${state.showId}`);
        }
    }, [state.showId, navigate]);

    function handleShowCreate(show) {
        dispatch({ type: ACTIONS.SHOW_CREATE_CALL });


        contextValue.showLoader();
        contextValue.updateLoaderText("Creating show...");

        const formData = new FormData();
        const data = show;
        // Append normal text fields
        formData.append("name", data.name);
        formData.append("status", data.status);
        formData.append("WebsiteUrl", data.WebsiteUrl || "");
        formData.append("startDateTime", data.startDateTime);
        formData.append("endDateTime", data.endDateTime);
      
        // Append files (pick the first file from FileList)
        if (data.ThumbImage?.[0]) formData.append("ThumbImage", data.ThumbImage[0]);
        if (data.FeedImage?.[0]) formData.append("FeedImage", data.FeedImage[0]);
        if (data.ResultImage?.[0]) formData.append("ResultImage", data.ResultImage[0]);
        if (data.HeaderImage?.[0]) formData.append("HeaderImage", data.HeaderImage[0]);



        showService.createShow(formData)
        .then(response => 
            {
                toast.success("Show created successfully");
                dispatch({ type: ACTIONS.SHOW_CREATE_SUCCESS, data: response.data })
            }
        
        )
        .catch(error =>{
            toast.error("Error creating show");
            dispatch({ type: ACTIONS.SHOW_CREATE_ERROR, data: error.response.data })
        })
        .finally(() => contextValue.hideLoader());



        // .then(response => dispatch({ type: ACTIONS.SHOW_CREATE_SUCCESS, data: response.data }))
        // .catch(error => dispatch({ type: ACTIONS.SHOW_CREATE_ERROR, data: error.response.data }));
    }
    function renderStatusOptions() {
        return statusOptions.map((item) => (
            <option key={`status${item}`} value={item}>{item}</option>
        ));
    }
    return (
        <form onSubmit={handleSubmit(handleShowCreate)} >
            <div className="mb-3">
                <label htmlFor="newShowName" className="form-label">Name of show to be added (Max 46 characters)</label>
                <input type="text" className="form-control" id="newShowName"
                max={46}
                autoComplete='off' {...register('name', {required: true})}/>
                {errors.name?.type === 'required' && <div className='text-danger form-text'>Name is required</div>}
            </div>

            <div className='col'>
            <label htmlFor='showStatus' className='form-label'>Status:</label>
                <select className='form-select' id='showStatus' autoComplete='off' {...register('status')} >
                    {renderStatusOptions()}
                </select>
            </div>
            <div className="mb-3">
                <label htmlFor="newShowWeb" className="form-label">Link to Show's Website</label>
                <input type="text" className="form-control" id="newShowWeb"
                autoComplete='off' {...register('WebsiteUrl')}/>
            </div>

            <div className="mb-3">
                <label htmlFor="newShowStartDateTime" className="form-label">Start Date and Time</label>
                <input type="datetime-local" className="form-control" id="newShowStartDateTime" autoComplete='off' {...register('startDateTime')}/>
            </div>
            <div className="mb-3">
                <label htmlFor="newEndStartTime" className="form-label">End Date and Time</label>
                <input type="datetime-local" className="form-control" id="newEndStartTime" autoComplete='off' {...register('endDateTime')}/>
            </div>


            <div className="mb-3">
                <label htmlFor="ThumbImage" className="form-label">Show list image (750w x 500h pixels)</label>
                <input type="file" className="form-control" id="ThumbImage"
                {...register('ThumbImage')}/>
            </div>
            <div className="mb-3">
                <label htmlFor="FeedImage" className="form-label">Show full page image (750w x 1334h pixels)</label>
                <input type="file" className="form-control" id="FeedImage"
                {...register('FeedImage')}/>
            </div>
            <div className="mb-3">
                <label htmlFor="ResultImage" className="form-label">Show results page image (750w x 1334h pixels)</label>
                <input type="file" className="form-control" id="ResultImage"
                {...register('ResultImage')}/>
            </div>
            <div className="mb-3">
                <label htmlFor="HeaderImage" className="form-label">Show header image (750w x 350h pixels)</label>
                <input type="file" className="form-control" id="HeaderImage"
                {...register('HeaderImage')}/>
            </div>






            {state.serverCommunication && <p className='text-danger'>{state.serverCommunication.messages}</p>}
            <button className='btn btn-success text-white w-100' type='submit'>Create</button>
        </form>
    );
}

export default ShowCreate;